import { Box, Flex, Text, IconButton, Button, Stack, Collapse, Icon, Popover, PopoverTrigger, PopoverContent, useColorModeValue, useBreakpointValue, useDisclosure, useColorMode } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon, ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import { Link as ReatLink } from "react-router-dom";
import { Link  } from "react-scroll";
import resume from "../Assests/Kalyan-Kumar-Resume.pdf"
export default function Navbar() {
  const { isOpen, onToggle } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const bgColor = { light: 'white', dark: 'dark.bg' };
  const textColor = { light: 'gray.600', dark: 'dark.text' };
const resumeurl=resume
const handleClick = () => {
  window.open(
    `https://drive.google.com/file/d/1GMDpYcl0BKf8UGT1ropTvW6gAaQA1fxb/view?usp=sharing`,
    "_blank",
    "noopener",
    "noreferrer"
  );
};
  return (
    <Box   position="sticky"
    id="nav-menu"
    top="0"
    backgroundColor="white"
    transition="box-shadow 0.3s"
    zIndex="1000"
    
  >
      <Flex
      align={"center"}
        bg={bgColor[colorMode]}
        color={textColor[colorMode]}
        minH="70px"
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={1}
        borderStyle="solid"
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        //align="center"
    
      
        
      >
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}
      
        
        >
          <IconButton
            onClick={onToggle}
            icon={isOpen ? <CloseIcon w={6} h={6} /> : <HamburgerIcon w={6} h={6} />}
            variant="ghost"
            aria-label="Toggle Navigation"
          />
        </Flex>
        <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
          <Text
            textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
            fontFamily="heading"
            fontSize={{ base: 'xl', md: '25px' }} // Adjust the font size to your preference
          >
            🅺🅰🅻🆈🅰🅽
          </Text>
          <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
            <DesktopNav />
          </Flex>
        </Flex>
   

        <Stack
          flex={{ base: 1, md: 0 }}
          justify="flex-end"
          direction="row"
          spacing={6}
        >
               <Box>
  <IconButton
    aria-label="Toggle Color Mode"
    icon={colorMode === 'light' ? <MoonIcon boxSize={6} /> : <SunIcon boxSize={6} />}
    onClick={toggleColorMode}
    variant="unstyled" // Use the "unstyled" variant to remove default styles
    _focus={{ outline: 'none' }} // Remove focus outline
  />
</Box>
<ReatLink   id="resume-link-1" to={resumeurl} target="_blank" download>
        <Button
           id="resume-button-1"
          className="nav-link resume"
          display={{ base: "none", md: "inline-flex" }}
          fontSize={"sm"}
          fontWeight={600}
          color={"white"}
          bg="pink.400"
            href="#"
            _hover={{
              bg: 'teal.500',
            }}
            onClick={handleClick}
            >
          Resume
        </Button>
      </ReatLink>
        </Stack>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  );
}

// Other components (DesktopNav, DesktopSubNav, MobileNav, MobileNavItem) remain unchanged.


const DesktopNav = () => {
  const linkColor = useColorModeValue('gray.600', 'gray.200');
  const linkHoverColor = useColorModeValue('gray.800', 'white');
  const popoverContentBgColor = useColorModeValue('white', 'gray.800');

  return (
    <Stack direction="row" spacing={4} id="nav-menu">
      {NAV_ITEMS.map((navItem) => (
        <Popover trigger="hover" placement="bottom-start" key={navItem.label}>
          <PopoverTrigger>
            <Box
              as="span" // Use a span instead of an anchor for the inner element
              p={2}
              fontSize="20px"
              fontWeight={500}
              color={linkColor}
              _hover={{
                textDecoration: 'none',
                color: linkHoverColor,
                bg: 'teal.400', // Change the background color on hover
                borderRadius: "5px"
                
              }}
            >
              <Link to={navItem.id} className={navItem.className}>
                {navItem.label}
              </Link>
            </Box>
          </PopoverTrigger>
          {navItem.children && (
            <PopoverContent
              border={0}
              boxShadow="xl"
              bg={popoverContentBgColor}
              p={4}
              rounded="xl"
              minW="sm"
            >
              {/* <Stack>
                {navItem.children.map((child) => (
                  <DesktopSubNav key={child.label} {...child} />
                ))}
              </Stack> */}
            </PopoverContent>
          )}
        </Popover>
      ))}
    </Stack>
  );
}




const MobileNav = () => {
  return (
    <Stack bg={useColorModeValue('white', 'gray.800')} p={4} display={{ md: 'none' }}>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  );
}

const MobileNavItem = ({ label, children, href ,id}) => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Link
      to={id}
        py={2}
        as="a"
        
        href={href ?? '#'}
        justify="space-between"
        align="center"
        _hover={{
          textDecoration: 'none',
          
        }}
      >
        <Text fontWeight={600} color={useColorModeValue('gray.600', 'gray.200')}>
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition="all .25s ease-in-out"
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={6}
            h={6}
          />
        )}
      </Link>
      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle="solid"
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align="start"
        >
          {children &&
            children.map((child) => (
              <Box as="a" key={child.label} py={2} href={child.href}>
                {child.label}
              </Box>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
}

const NAV_ITEMS = [
  {
    label: "Home",
    id: "home",
    className:"nav-link home"
  },
  {
    label: "About",
    id: "about",
    className: "nav-link about",
  },
  {
    label: "Experiance",
    id: "experiance",
    className: "nav-link experiance",
  },
    
  {
    label: "Skills",
    id: "skills",
    className: "nav-link skills",
  },
  {
    label: "Project",
    id: "projects",
    className: "nav-link projects",
  },
  {
    label: "Contact",
    id: "contact",
    className: "nav-link contact",
  },
];
